import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumMapper'
})
export class EnumMapperPipe implements PipeTransform {
  transform(value: string | number, en: any): unknown {
    return en[value];
  }
}
